<template>
  <div class="ca-pesquisa-lista">
    <template v-if="loading">
      <div v-for="i in 5" :key="i" class="ca-pesquisa-lista__shimmer">
        <div class="ca-pesquisa-lista__shimmer-title"></div>
        <div class="ca-pesquisa-lista__shimmer-subtitle"></div>
        <div class="ca-pesquisa-lista__shimmer-tag"></div>
      </div>
    </template>

    <ul v-else class="ca-pesquisa-lista__list gap-size-6">
      <li
        v-for="(result, idx) in results"
        :key="idx"
        class="ca-pesquisa-lista__item"
      >
        <a :href="result.url" class="ca-pesquisa-lista__link">
          <span class="ca-pesquisa-lista__titulo heading-regular mb-size-4">{{
            result.title
          }}</span>
          <span class="ca-pesquisa-lista__subtitulo caption-large">{{
            result.subtitle
          }}</span>
          <!-- <span class="ca-pesquisa-lista__categoria gap-size-2 caption-medium">
          <component
            :is="categoryIcons[result.categoryIcon]"
            class="ca-pesquisa-lista__icone"
            aria-hidden="true"
          />
          {{ result.category }}
        </span> -->
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import IconLista from "@assets/lista.svg";
import IconCarteira from "@assets/carteira.svg";
import IconDocumento from "@assets/documento.svg";

const categoryIcons = {
  ajuda: IconLista,
  produtos: IconCarteira,
  servicos: IconDocumento,
};

defineProps({
  results: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});
</script>

<style scoped lang="scss">
.ca-pesquisa-lista {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__list {
    list-style: none;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    width: 100%;
  }

  &__item {
    padding: 0;
    width: 100%;

    &:not(:last-child) {
      border-bottom: 0.5px solid var(--ca-color-text-light);
    }
  }

  &__link {
    display: block;
    text-decoration: none;

    &:hover .ca-pesquisa-lista__titulo {
      color: var(--ca-color-hover-pressed-primary-hover);
    }

    &:focus-visible {
      outline: 1px solid var(--ca-color-feedback-info);
      outline-offset: 2px;
      border-radius: 10px;
    }
  }

  &__titulo {
    display: block;
    color: var(--ca-color-text-body);
    transition: color 0.15s ease;
  }

  &__subtitulo {
    display: block;
    color: var(--ca-color-text-body-variant);
    margin: 0 0 var(--size-6) 0;
  }

  &__categoria {
    display: inline-flex;
    align-items: center;
    color: var(--ca-color-text-body);
    text-transform: uppercase;
  }

  &__icone {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: inherit;
  }

  &__shimmer {
    width: 100%;
    padding: var(--size-4) 0;
    border-bottom: 0.5px solid var(--ca-color-text-light);

    &:first-child {
      padding-top: 0;
    }
  }

  &__shimmer-title,
  &__shimmer-subtitle,
  &__shimmer-tag {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    border-radius: 6.507px;
    animation: shimmer 1.5s infinite;
  }

  &__shimmer-title {
    height: 18px;
    width: 80%;
    margin-bottom: var(--size-2);
  }
  &__shimmer-subtitle {
    height: 14px;
    width: 40%;
    margin-bottom: var(--size-3);
  }
  &__shimmer-tag {
    height: 12px;
    width: 25%;
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
}
</style>
